import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import BookingFlow from '../components/BookingFlow';

// Map ?type= value (with common aliases) to a valid vehicle type
const VEHICLE_ALIASES = {
  tungbil: 'tungbil',
  lastebil: 'tungbil',
  buss: 'tungbil',
  tilhenger: 'tilhenger',
  henger: 'tilhenger',
  personbil: 'personbil',
  bil: 'personbil',
  varebil: 'personbil',
};

const resolveVehicleType = (raw) => {
  if (!raw) return '';
  return VEHICLE_ALIASES[raw.trim().toLowerCase()] || '';
};

// Build a friendly prefilled note from ?service=
const buildNote = (rawService) => {
  if (!rawService) return '';
  const pretty = rawService.trim().replace(/[-_]+/g, ' ');
  return `Ønsket tjeneste: ${pretty}`;
};

const BookingPage = () => {
  const [searchParams] = useSearchParams();

  const initialVehicleType = useMemo(
    () => resolveVehicleType(searchParams.get('type')),
    [searchParams]
  );
  const initialNotes = useMemo(
    () => buildNote(searchParams.get('service')),
    [searchParams]
  );

  return (
    <div className="min-h-screen bg-slate-50 flex items-start justify-center py-10 px-4" data-testid="booking-page">
      <Helmet>
        <title>Book time | Sand-tec AS</title>
        <meta name="description" content="Book time for EU-kontroll, service eller reparasjon hos Sand-tec AS. Velg dato, tidspunkt og fyll inn dine detaljer." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="w-full max-w-3xl">
        {/* Heading */}
        <div className="text-center mb-8">
          <h1 className="text-4xl sm:text-5xl font-black text-gray-900">
            <span className="bg-gradient-to-r from-red-600 to-yellow-500 bg-clip-text text-transparent">
              Book time
            </span>
          </h1>
          <p className="text-gray-600 mt-2 text-base">
            Velg dato, tidspunkt og fyll inn dine detaljer
          </p>
        </div>

        {/* Self-contained dark card (renders cleanly inside an iframe) */}
        <div className="bg-gray-900 border border-gray-800 rounded-2xl shadow-xl p-6 sm:p-8 text-white">
          <BookingFlow
            mode="standalone"
            initialVehicleType={initialVehicleType}
            initialNotes={initialNotes}
          />
        </div>

        <p className="text-center text-gray-400 text-xs mt-6">
          Sand-tec AS · Industrivegen 4, 2120 Sagstua
        </p>
      </div>
    </div>
  );
};

export default BookingPage;
